import React from 'react';
import { motion } from 'framer-motion';
import { Link } from 'react-router-dom';
import { ArrowRight } from 'lucide-react';
export function VsIndex() {
  const comparisons = [{
    name: 'Lindy.ai',
    tagline: 'AI assistant vs full business automation',
    link: '/vs/lindy-ai',
    color: 'border-teal'
  }, {
    name: 'Zapier',
    tagline: 'Workflow automation vs a running business',
    link: '/vs/zapier',
    color: 'border-purple'
  }, {
    name: 'HubSpot',
    tagline: 'CRM platform vs complete AI operations',
    link: '/vs/hubspot',
    color: 'border-red-cta'
  }];
  return <main className="pt-20" data-id="element-2875">
      {/*
              Title: MindStream.ing vs Competitors — See Every Comparison
            */}
      <section className="relative pt-24 pb-20 lg:pt-32 lg:pb-28 px-6 bg-hero-gradient min-h-[60vh] flex flex-col justify-center overflow-hidden" data-id="element-2876">
        {/* Ambient Glow Orbs */}
        <div className="absolute top-0 right-0 w-[600px] h-[600px] bg-purple/20 rounded-full blur-[120px] opacity-30 pointer-events-none" data-id="element-2877" />
        <div className="absolute bottom-0 left-0 w-[500px] h-[500px] bg-teal/20 rounded-full blur-[100px] opacity-20 pointer-events-none" data-id="element-2878" />

        {/* Grid Pattern Overlay */}
        <div className="absolute inset-0 opacity-[0.03] pointer-events-none" style={{
        backgroundImage: `radial-gradient(circle, white 1px, transparent 1px)`,
        backgroundSize: '40px 40px'
      }} data-id="element-2879" />

        <div className="inner-container relative z-10 text-center max-w-4xl mx-auto mb-16" data-id="element-2880">
          <motion.div initial={{
          opacity: 0,
          y: 20
        }} animate={{
          opacity: 1,
          y: 0
        }} transition={{
          duration: 0.5
        }} data-id="element-2881">
            <h1 className="font-poppins font-extrabold text-5xl md:text-6xl leading-tight mb-6" data-id="element-2882">
              MISTR vs Everyone.
              <br data-id="element-2883" />
              <span className="text-gradient" data-id="element-2884">Pick Your Fight.</span>
            </h1>
            <p className="text-lg md:text-xl text-steel" data-id="element-2885">
              See exactly why business owners are switching to full AI business
              automation.
            </p>
          </motion.div>
        </div>

        <div className="inner-container max-w-5xl" data-id="element-2886">
          <div className="grid md:grid-cols-3 gap-6" data-id="element-2887">
            {comparisons.map((comp, i) => <motion.div key={i} initial={{
            opacity: 0,
            y: 20
          }} animate={{
            opacity: 1,
            y: 0
          }} transition={{
            duration: 0.5,
            delay: i * 0.1
          }} data-id="element-2888">
                <Link to={comp.link} className={`block bg-gradient-to-br from-white/[0.05] to-white/[0.02] backdrop-blur-sm rounded-xl p-8 border-l-4 ${comp.color} border-y border-r border-white/10 shadow-lg hover:shadow-[0_0_30px_rgba(255,255,255,0.1)] hover:-translate-y-1 transition-all group`} data-id="element-2889">
                  <div className="text-sm text-steel mb-2" data-id="element-2890">vs</div>
                  <h2 className="font-poppins font-bold text-3xl mb-4 group-hover:text-white transition-colors" data-id="element-2891">
                    {comp.name}
                  </h2>
                  <p className="text-white/80 mb-8 h-12" data-id="element-2892">{comp.tagline}</p>
                  <div className="flex items-center gap-2 text-teal font-semibold group-hover:gap-3 transition-all" data-id="element-2893">
                    See Full Comparison <ArrowRight size={18} data-id="element-2894" />
                  </div>
                </Link>
              </motion.div>)}
          </div>

          <motion.div initial={{
          opacity: 0
        }} animate={{
          opacity: 1
        }} transition={{
          delay: 0.6
        }} className="text-center mt-16" data-id="element-2895">
            <p className="text-steel mb-4" data-id="element-2896">Don't see your tool?</p>
            <Link to="/contact" className="btn-ghost inline-block" data-id="element-2897">
              Talk to MR and we'll show you the difference
            </Link>
          </motion.div>
        </div>
      </section>
    </main>;
}